import {memo} from 'react';

import {MenuItem, MenuItemProps, Typography} from '@mui/material';
import {FlagImage, ParsedCountry} from 'react-international-phone';

import {FLAG_STYLE} from './constants';

interface CountryMenuItemProps extends Omit<MenuItemProps, 'value'> {
  value: string;
  country: ParsedCountry;
}

function CountryMenuItemComponent({
  value,
  country,
  ...menuItemProps
}: CountryMenuItemProps) {
  // MUI's Select clones each child with interaction props (onClick, selected,
  // role, aria-selected, onKeyUp, data-value) so selecting an option works —
  // they must be spread onto the real MenuItem or clicks silently do nothing.
  // See https://mui.com/material-ui/react-select/ ("Wrapping a MenuItem").
  return (
    <MenuItem
      value={value}
      {...menuItemProps}>
      <FlagImage
        iso2={country.iso2}
        style={FLAG_STYLE}
      />
      <Typography marginRight="8px">{country.name}</Typography>
      <Typography color="gray">+{country.dialCode}</Typography>
    </MenuItem>
  );
}

// MUI's Select special-cases direct children it recognizes as MenuItem (via a
// `muiName` static) for keyboard navigation and scroll-into-view. Wrapping
// MenuItem in our own component hides that unless we re-declare it here —
// see https://mui.com/material-ui/react-select/ ("Wrapping a MenuItem").
export const CountryMenuItem = Object.assign(memo(CountryMenuItemComponent), {
  muiName: 'MenuItem',
});
